import { DepartmentOption } from "@common/components/SelectDepartment";
import { StipendCategory, StipendRuleFrequency } from "@common/utils/graphql";

export const getFrequencyDisplay = (frequency?: StipendRuleFrequency) => {
  if (frequency === StipendRuleFrequency.Daily) {
    return "Daily (weekdays)";
  } else if (frequency === StipendRuleFrequency.OneTime) {
    return "One Time";
  } else if (frequency === StipendRuleFrequency.Monthly) {
    return "Monthly";
  }
  // we should never reach here
  return "Custom";
};

export const getDepartmentDisplay = (departments: DepartmentOption[]) => {
  if (departments.length === 1) {
    return departments[0].name;
  }
  if (departments.length === 2) {
    return `${departments[0].name} and ${departments[1].name}`;
  }
  return `${departments[0].name} and ${departments.length - 1} more`;
};

const categoryDisplayMap = {
  [StipendCategory.Wellness]: "Wellness",
  [StipendCategory.Food]: "Food",
  [StipendCategory.Travel]: "Travel",
  [StipendCategory.Commute]: "Commute",
  [StipendCategory.Fitness]: "Fitness",
  [StipendCategory.Network]: "Network",
  [StipendCategory.Education]: "Education",
  [StipendCategory.Healthcare]: "Healthcare",
  [StipendCategory.Celebration]: "Celebration",
  [StipendCategory.Convenience]: "Convenience",
  [StipendCategory.Connectivity]: "Connectivity",
  [StipendCategory.Entertainment]: "Entertainment",
};
export const getCategoryDisplay = (category: StipendCategory) =>
  categoryDisplayMap[category];
